module.exports = __webpack_public_path__ + "static/media/heart-icon.on.6af73f5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/heart-icon.on.svg
// module id = 523
// module chunks = 0